<template>
 <v-dialog v-model="show" persistent max-width="600px">
    <v-card  height="70vh">

                             <v-toolbar
          color="yellow lighten-1"
          dark
        >

          <v-toolbar-title  class="headline">Alla ärenden</v-toolbar-title>
        </v-toolbar>
           
            <v-card-text>
              <v-container>
                <v-flex>
                     <v-flex cols="12" sm="6">
                    <v-select
                      v-model="myCasesNames"
                      :items="casesnames"
                      attach
                      chips
                      label="Vilka ärenden vill du prenumerera på?"
                      multiple
                    ></v-select>
                  </v-flex>
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark color="red darken-1" @click="show = false">
                Stäng
              </v-btn>
              <v-btn
                color="green lighten-1"
                text
                dark
                @click="AddRemove_Case()"
              >
                Prenumerera
              </v-btn>
            </v-card-actions>
          </v-card>
 </v-dialog>
</template>
<script>
import { mapActions,mapGetters } from "vuex";
export default {
    name:"Subscribe",

  computed: {
    
    ...mapGetters('cases', ['cases', 'casesnames']),
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },

    created(){
      if (this.myCases.length!=0) {
   this.myCasesNames= this.myCases.map(Case => Case.name)
  this.oldCasesNames= this.myCases.map(Case => Case.name)

      }
 
  this.initcasesEHT(this.schoolId);
    },
    props:{
        myCases: Array,
        id: String,
        schoolId: String,
        value: Boolean
    },
data() {
    return {
      myCasesNames: [],
      oldCasesNames: [],
    };
  },
  methods: {
    
    ...mapActions(['showSuccessSnackbar']),
    ...mapActions('cases', ['initcasesEHT','subscribe']),
    ...mapActions('teachers', ['updateCases']),
     AddRemove_Case() {
       let New=[]
       let Old=[]
       let Gone=[]
       let myNewCases=[]
      this.myCasesNames.forEach(name => {
        // (name)
        let exist=this.myCases.find(Case=> Case.name==name)
        if (exist!=null) {
       myNewCases.push(exist)
        Old.push(name)
}
else
{
myNewCases.push(this.cases.find(Case=>Case.name==name))
New.push(name)
}
      });
      // (this.myCasesNames)
      // (this.oldCasesNames)
  this.oldCasesNames.forEach(name => {
        // (name)
        let exist=myNewCases.find(Case=> Case.name==name)
        if (exist==null) {
Gone.push(name)
}
      });
      // // (New)
      // // (Old)
      // // (Gone)
      // // (myNewCases)
      this.subscribe([New,Gone,this.id]);
      this.updateCases(myNewCases)
      this.showSuccessSnackbar("Dina prenumerationer är uppdaterade.")
      this.show = false;
    },
    
  }
}
</script>
<style >

</style>